export const TechStack = () => {
  return (
    <section className="max-w-4xl mx-auto px-4 mb-20 text-lg text-gray-900">
      <h1 className='text-center font-mono text-5xl py-20 mb-4'>About This Site</h1>
      <p>This site is currently built with vanilla the React Javascript framework with static content, and using&nbsp;
        <a className="text-yellow-600 hover:text-yellow-500" target="_blank" rel="noreferrer" href="https://tailwindcss.com/">Tailwind CSS</a>
        &nbsp; for all of the styling.
      </p>
      <h3 className="font-bold mt-5">Why React?</h3>
      <p className="mt-5">First and formost, I really like creating websites with React. I feel that is is important to use the tools that I intend to use everyday so I can keep improving my ability to write better javascript.</p>
      <p className="mt-5">As for the second reason, I would like to eventually implement a headless CMS (wordpress) and move all of my content into custom post types to make adding new portfolio items and potentially a blog much more user friendly.</p>
      <p>   
         
      </p>
    </section>
  )
}